import React, { useState } from "react";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import IconDelete from "canvas-core-react/lib/IconDelete";
import IconShow from "canvas-core-react/lib/IconShow";
import IconSuccess from "canvas-core-react/lib/IconSuccessUniversal";
import StatusBadge from "canvas-core-react/lib/StatusBadge";
import { useDispatch, useSelector } from "react-redux";
import * as instanceActions from "../../../Redux/api";
import DinamicTable from "../../shared/table";
import Detail from "../provider/relationDetail/relationDetail";
import Modal from "../../utils/customModal";
import {
  errorContainer,
  loadingHtml,
  moduleAction,
  sucessInfoModal,
} from "../../utils/functions";
import { MOD_CUSTOM, WRITE } from "../../../permissions";
import { getRoles } from "../../../Redux/reducer/session";
import useApi from "../../hooks/useApi";
import { useTranslation } from "react-i18next";
import { LABELS_ACCOUNT_TYPE } from "../../shared/AccountTypeSelect";
import i18next from "i18next";
/* import CustomCheckbox from "../../shared/custom-components/checkbox"; */
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";

const defaultModal = {
  show: false,
  content: null,
  onClose: undefined,
};

const sucessMessage = i18next.t(
  "general.modal.global_approval.success_message"
);

const TableClientsByProvider = ({
  showDetails,
  data,
  totalSize,
  details,
  getAllProviders,
  ...rest
}) => {
  const [state, setState] = useState({
    page: 0,
    sizePerPage: rest.sizePerPage,
    item: {},
    list: true,
    institution: {},
    menus: [],
  });

  const [modal, setModal] = useState(defaultModal);
  const [selectedClients, setSelectedClients] = useState({});

  const roles = useSelector((state) => getRoles(state));

  const { putApiCAll } = useApi();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const closeModal = () => setModal(defaultModal);

  /*   const handleSelectedClients = ({ id, providerId, companyId }) => {
    setSelectedClients((prev) => {
      if (prev[id]) {
        // eslint-disable-next-line no-unused-vars
        const { [id]: prop, ...restObj } = prev;
        return restObj;
      }
      return { ...prev, [id]: { providerId, companyId } };
    });
  }; */

  const getTableColumns = () => {
    const { menus } = state;

    return [
      {
        grow: 2,
        selector: "institutionName",
        name: `${t(
          "general.provider_account_detail.clients.table.headers.client_name"
        )}`,
      },
      {
        grow: 2,
        selector: "cif",
        name: `${t(
          "general.provider_account_detail.clients.table.headers.cif"
        )}`,
      },
      {
        grow: 2,
        selector: "identification",
        name: `${t(
          "general.provider_account_detail.clients.table.headers.idClient"
        )}`,
      },
      {
        grow: 2,
        selector: "account",
        name: `${t(
          "general.provider_account_detail.clients.table.headers.provider_account"
        )}`,
      },
      {
        grow: 2,
        selector: "accountType",
        name: `${t(
          "general.provider_account_detail.clients.table.headers.account_type"
        )}`,
      },
      {
        grow: 2,
        selector: "status",
        name: `${t(
          "general.provider_account_detail.clients.table.headers.relation_status"
        )}`,
      },
      {
        grow: 2,
        selector: "relationType",
        name: `${t(
          "general.provider_account_detail.clients.table.headers.relation_type"
        )}`,
      },
      /*      {
        grow: 2,
        selector: "Onboarding",
        name: "Onboarding",
        center: true,
      }, */
      {
        grow: 2,
        selector: "globalApprove",
        name: `${t(
          "general.provider_account_detail.clients.table.headers.globalApproval"
        )}`,
      },
      {
        grow: 2,
        selector: "actions",
        name: `${t("logs.detail.table.action")}`,
        center: true,
        cellFormatter: (row) => {
          return (
            <ActionMenuList
              dialogPosition="bottom-right"
              iconType="horizontal-small"
              bottomSheet={{
                heading: "Actions",
                secondaryAction: {
                  onClick: () => {},
                  label: "Cancel",
                },
              }}
              isMenuOpen={
                menus[`menu-${row?.idCompany}-${row.accountCurrency}`] || false
              }
              setIsMenuOpen={(open) =>
                handleMenu(`${row?.idCompany}-${row.accountCurrency}`, open)
              }
            >
              <ActionMenuListItem
                icon={() => (
                  <IconShow
                    id={`client-approval-${row?.idCompany}`}
                    className="TextButton__icon--left"
                  />
                )}
                onClick={() => loadCompanyTemp(row)}
              >
                {t("general.labels.fileModal.detail")}
              </ActionMenuListItem>
              {row.relationType !== "DDAY" &&
                moduleAction(roles, MOD_CUSTOM, WRITE) && (
                  <ActionMenuListItem
                    icon={() => (
                      <IconSuccess
                        id={`client-approval-${row?.idCompany}`}
                        className="TextButton__icon--left"
                      />
                    )}
                    onClick={() => globalApproval(row)}
                  >
                    {t("general.labels.globalApproval")}
                  </ActionMenuListItem>
                )}
              {moduleAction(roles, MOD_CUSTOM, WRITE) && (
                <ActionMenuListItem
                  icon={() => (
                    <IconDelete
                      id={`client-approval-${row?.idCompany}`}
                      className="delete-action"
                    />
                  )}
                  onClick={() => handleConfirmDelete(row)}
                >
                  {t("general.labels.fileModal.deleteRelation")}
                </ActionMenuListItem>
              )}
            </ActionMenuList>
          );
        },
      },
    ];
  };

  const loadCompanyTemp = (row) => {
    setState((prev) => ({
      ...prev,
      menus: [],
      item: row,
      list: false,
    }));
    setTimeout(() => showDetails(), 0);
  };

  const handleMenu = (id, open) => {
    const { menus } = state;
    menus[`menu-${id}`] = open;
    setState((prev) => ({ ...prev, menus }));
  };

  const globalApproval = (item) => {
    handleMenu(`${item.idCompany}-${item.accountCurrency}`, false);

    let title =
      item.globApproval === true
        ? t("general.modal.global_approval.title_off")
        : t("general.modal.global_approval.title_on");
    let message = t("general.modal.global_approval.message");
    let buttons = {
      SelBtn: {
        text: t("general.buttons.cancel"),
        action: closeModal,
      },
      formBtn: {
        text: t("general.buttons.accept"),
        action: () => updateGlobalApproval(item),
      },
    };

    setModal({
      show: true,
      onClose: closeModal,
      content: sucessInfoModal(title, message, buttons),
    });
  };

  const onLoadingModal = () => {
    setModal({
      show: true,
      content: loadingHtml(),
      onClose: undefined,
    });
  };

  const updateGlobalApproval = async (row) => {
    const data = {
      companyId: row.idCompany,
      globalAcceptance: !row.globApproval,
      providerId: row.idProvider,
      currency: row.accountCurrency,
    };

    onLoadingModal();

    try {
      await dispatch(
        instanceActions.instanceAction(
          `/providers/global-approval`,
          "put",
          data
        )
      );

      let title = t("general.modal.global_approval.approval_success");

      let buttons = { formBtn: { text: "Aceptar", action: closeModal } };

      setModal((prev) => ({
        ...prev,
        show: true,
        content: sucessInfoModal(title, sucessMessage, buttons),
        onClose: closeModal,
      }));
    } catch (err) {
      let title = "Error";
      let message = t("general.modal.global_approval.error_message");
      let buttons = { formBtn: { text: "Aceptar", action: closeModal } };

      setModal((prev) => ({
        ...prev,
        show: true,
        content: sucessInfoModal(title, message, buttons),
        onClose: closeModal,
      }));
    }
  };

  const setTableData = () => {
    const dataResult = [];
    let estado = null;

    if (data.length > 0) {
      data.map((item) => {
        if (item.provider.status === "TRANSITORY") {
          estado = (
            <StatusBadge
              className="pending provider-table-attribute"
              type="default"
            >
              {t("general.placeholders.pending")}
            </StatusBadge>
          );
        } else if (item.provider.status === "ACTIVE") {
          estado = (
            <StatusBadge
              className="success provider-table-attribute"
              type="success"
            >
              {t("general.placeholders.active")}
            </StatusBadge>
          );
        } else if (item.provider.status === "INACTIVE") {
          estado = (
            <StatusBadge
              className="error1 provider-table-attribute"
              type="error"
            >
              {t("general.placeholders.inactive")}
            </StatusBadge>
          );
        } else if (item.provider.status === "REJECTED") {
          estado = (
            <StatusBadge
              className="rejected-payment provider-table-attribute"
              type="error"
            >
              {t("general.placeholders.rejected")}
            </StatusBadge>
          );
        }

        const getLabel = (value, [first, second], options) => {
          const property = value ? first : second;
          return t(`general.${options}.${property}`)?.toUpperCase();
        };

        const idProvider = item.provider.id;
        const idCompany = item.provider.relation.company.id;
        const accountCurrency =
          item?.provider?.accounts[0]?.accountCurrency ?? "";

        const id = item.id;
        /*       const customId = `${id}-${accountCurrency}`;

        const selectedProps = {
          id: customId,
          providerId: idProvider,
          companyId: idCompany,
        }; */

        dataResult.push({
          id,
          identification: item.provider.relation.businessId,
          idProvider,
          idCompany,
          institutionName: item.provider.relation.name,
          bank: item.provider.name,
          status: estado,
          accountCurrency,
          cif: item.provider.relation.cif,
          globalApprove: getLabel(
            item.provider.globalApproval,
            ["yes", "no"],
            "labels"
          ),
          globApproval: item.provider.globalApproval,
          account: item.provider.accounts[0]?.accountNumber,
          accountType:
            LABELS_ACCOUNT_TYPE[item.provider.accounts[0]?.accountType] ||
            item.provider.accounts[0]?.accountType,
          relationType: getLabel(
            item.provider.toBillDiscount,
            ["DISCOUNT", "DDAY"],
            "states"
          ),
          /*       Onboarding: (
            <CustomCheckbox
              onChange={() => handleSelectedClients(selectedProps)}
              checked={!!selectedClients[customId]}
            />
          ), */
        });
      });
    }

    return dataResult;
  };

  const handleTableChange = async ({
    page,
    sizePerPage,
    sort = "",
    property = "",
  }) => {
    var filters =
      property !== "" && property !== null
        ? [{ property: "sort", value: `${property},${sort}` }]
        : [];

    await getAllProviders(page, sizePerPage, filters);
    setState((prev) => ({
      ...prev,
      page,
      sizePerPage,
      order: sort,
      sortBy: property,
    }));
  };

  const handleConfirmDelete = (row) => {
    handleMenu(`${row.idCompany}-${row.accountCurrency}`, false);
    setModal({
      show: true,
      content: errorContainer(
        t("clients.deleteRelationTitle"),
        t("clients.deleteRelationDescription"),
        {
          cancelBtn: { action: closeModal, text: t("general.buttons.cancel") },
          continueBtn: {
            action: () => onDeleteRelation(row),
            text: t("general.buttons.confirm"),
          },
        }
      ),
      onClose: undefined,
    });
  };

  const handleClearSelected = () => setSelectedClients({});

  const onSubmitNotifications = async () => {
    onLoadingModal();
    const clients = Object.keys(selectedClients).map((item) => {
      const { providerId, companyId } = selectedClients[item];
      const [, currency] = item.split("-");
      return {
        providerId,
        companyId,
        contractWasSigned: true,
        currency,
      };
    });
    try {
      await putApiCAll("/companies/contract-was-signed", clients);
      closeModal();
      setSelectedClients({});
    } catch (err) {
      setModal({
        show: true,
        content: sucessInfoModal(
          "Error",
          err.response.data.notifications[0].description,
          { formBtn: { text: "Aceptar", action: closeModal } }
        ),
        onClose: closeModal,
      });
    }
  };

  const onDeleteRelation = async ({
    accountCurrency,
    idCompany: companyId,
    idProvider: providerId,
  }) => {
    onLoadingModal();
    let title = t("general.modal.global_approval.delete_success");
    let message = sucessMessage;
    let buttons = { formBtn: { text: "Aceptar", action: closeModal } };
    try {
      await putApiCAll("/providers/remove-provider-company", {
        providerId,
        companyId,
        accountCurrency,
      });
    } catch (err) {
      title = "Error";
      message = err.response.data.notifications[0].description;
    }
    setModal({
      show: true,
      content: sucessInfoModal(title, message, buttons),
      onClose: closeModal,
    });
  };

  const renderActions = () => {
    const buttonText = t("general.buttons", { returnObjects: true });
    const disabled = Object.keys(selectedClients).length === 0;

    return (
      <div className="form-actions form-actions-clear">
        <SecondaryButton onClick={handleClearSelected} disabled={disabled}>
          {buttonText.clear}
        </SecondaryButton>
        <SecondaryButton onClick={onSubmitNotifications} disabled={disabled}>
          {buttonText.sendNotification}
        </SecondaryButton>
      </div>
    );
  };

  const { page, item, sizePerPage } = state;

  return (
    <>
      {!details ? (
        <DinamicTable
          headers={getTableColumns()}
          data={setTableData()}
          page={page}
          totalSize={totalSize}
          sizePerPage={sizePerPage}
          onTableChange={handleTableChange}
          actions={renderActions()}
        />
      ) : (
        <Detail
          idCompany={item?.idCompany}
          accountCurrency={item?.accountCurrency}
          idProvider={item?.idProvider}
          goBack={showDetails}
        />
      )}
      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
    </>
  );
};

export default TableClientsByProvider;
